import type { SelectPanelScrollBarProps } from "./types-select-panel-scroll-bar";
import { useSelectPanelScrollBar } from "./use-select-panel-scroll-bar";
import { SelectPanelScrollBarView } from "./view-select-panel-scroll-bar";

export function SelectPanelScrollBar(props: SelectPanelScrollBarProps) {
  const viewModel = useSelectPanelScrollBar(props);
  return <SelectPanelScrollBarView {...viewModel} />;
}
